import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL } from '../settings'
import { useAuth } from '../Hooks/useAuth'
import monthsParser from '../Utils/monthsParser'
import DataTableRowComponent from './DataTableRowComponent'
import popupAlert from '../Utils/Alerts/popupAlert'

const DataTables = ({ data, fetchData }) => {
    const headers = [ 'Month', 'Lead Funnel', 'Leads Achieved', 'Leads Target', "MQL Achieved", "MQL Target", "SQL Achieved", "SQL Target", "" ]
    const { user, filteredFunnel, setFilteredFunnel, reversed, setReversed } = useAuth()
    const [ tableData, setTableData ] = useState(null)

    // Fetch the data from the server
    const fetchTableData = async () => {
        return await axios.get(`${API_URL}/dashboard/table-data/${data.year}`, { headers: { token: user.token} })
        .then(res => filteredFunnel === null ? setTableData(res.data.data) : setTableData(res.data.data.filter(x => x.leadFunnel === filteredFunnel))).catch(err => console.log(err))
    }

    // Remove cached data in data state
    const removeCachedData = async () => {
        return await axios.get(`${API_URL}/dashboard/remove-cache`, { headers: { token: user.token} })
        .then(res => popupAlert(res.data, 'success')).catch(err => console.log(err))
    }
    
    useEffect(() => {
        fetchTableData()
    }, [ data.year, data, filteredFunnel ])

    const sortData = (data, key) => reversed ? data.sort((a, b) => a[key] > b[key] ? 1 : -1).reverse() : data.sort((a, b) => a[key] > b[key] ? 1 : -1)

    if (tableData) {
    return (
        <div className="mx-5 my-10 rounded-lg overflow-hidden shadow-2xl p-10">
                <div className='flex justify-start mb-10'>
                    <div>
                        {
                            filteredFunnel ? <button className='bg-transparent hover:ring-1 ring-pinegreen text-pinegreen font-semibold py-2 px-8 text-sm border border-pinegreen hover:border-transparent rounded-lg' onClick={() => setFilteredFunnel(null)}>{ filteredFunnel } <span className='text-darkgreen ml-5'>x</span></button> :
                            <select defaultValue="" onChange={e => setFilteredFunnel(e.target.value)} className="bg-gray-50 border border-pinegreen text-gray-900 text-sm rounded-lg focus:ring-mossgreen focus:border-mossgreen block w-100 p-2.5">
                                    <option disabled value="">Filter by Lead Funnel</option>
                                    { [ ...new Set(tableData.map(row => row.leadFunnel)) ].map((funnel, i) => <option key={i}>{funnel}</option>) }
                                </select>
                        }
                    </div>
                    <button onClick={() => setReversed(!reversed)} className='bg-transparent mx-4 hover:ring-1 ring-pinegreen text-label font-semibold text-sm py-2 px-8 border border-pinegreen hover:border-transparent rounded-lg'>Sort by Month</button>
                    <button onClick={() => removeCachedData()} className='bg-transparent mx-2 hover:ring-1 ring-pinegreen text-label font-semibold text-sm py-2 px-8 border border-pinegreen hover:border-transparent rounded-lg'>Remove Cached Data</button>

                </div>
                <h2 className="text-3xl text-center text-pinegreen font-semibold leading-tight">Year <span className='text-labelDark text-md'>{ data.year }</span></h2>
                <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                    <div className="inline-block min-w-full shadow rounded-lg overflow-hidden">
                        <table className="min-w-full leading-normal">
                            <thead className='w-full text-sm text-left text-gray-500 dark:text-gray-400'>
                                <tr className="border-b text-center">
                                    {   headers.map((header, index) => (
                                            <th key={index} className="px-5 py-3 border-b-2 border-mossgreen bg-pinegreen text-white text-xs font-semibold uppercase tracking-wider">
                                                { header }
                                            </th>
                                        ))
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {   
                                    sortData(tableData, "month").map((row, i) => (
                                        <tr key={i} className={`text-center border-b border-labelDark`}>
                                            <td className="px-5 py-5 bg-white text-md font-semibold text-label">
                                                { monthsParser(row.month) }
                                            </td>
                                            <td className="px-5 py-5 bg-white text-md text-pinegreen font-bold">
                                                { row.leadFunnel }
                                            </td>
                                            <DataTableRowComponent row={row} year={data.year} month={data.month} fetchData={fetchData} />
                                        </tr>
                                    )) 
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    } 
}
export default DataTables;